module.exports = __webpack_public_path__ + "static/media/V1.300a62a7.mp4";